import type { JourneyRadarItem } from './journey-radar';

export function summarizeWorkRadar(items: JourneyRadarItem[]) {
  const progressing = items.filter(
    (item) => item.attentionLevel === 'active'
  ).length;
  const delivered = items.filter((item) =>
    ['complete', 'closed'].includes(item.attentionLevel)
  ).length;
  const humanAction = items.filter(
    (item) => item.nextAction?.waitingOn === 'human'
  ).length;
  const failed = items.filter((item) => item.hasFailedSignal).length;
  const stale = items.filter((item) => item.isStale).length;
  const unlinked = items.filter((item) => item.hasLinkGap).length;
  const issueSummary = [
    humanAction ? `${humanAction} need a person` : '',
    failed ? `${failed} failed` : '',
    stale ? `${stale} stale` : '',
    unlinked ? `${unlinked} unlinked` : ''
  ]
    .filter(Boolean)
    .join(' · ');

  return {
    progressing,
    delivered,
    humanAction,
    failed,
    stale,
    unlinked,
    issueSummary
  };
}
